import { useState, type KeyboardEvent } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import { Send } from "@mui/icons-material";

interface MessageInputProps {
  onSend: (content: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export default function MessageInput({ onSend, disabled, placeholder }: MessageInputProps) {
  const [value, setValue] = useState("");

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  const onKey = (e: KeyboardEvent) => {
    // Enter to send; Shift+Enter for newline.
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: 1,
        p: 1.5,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={6}
        size="small"
        placeholder={placeholder ?? "Ask anything…"}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKey}
        disabled={disabled}
      />
      <IconButton color="primary" onClick={submit} disabled={disabled || !value.trim()}>
        <Send />
      </IconButton>
    </Box>
  );
}
